'use client'
import { Teams } from '@glovo/organisation'
import type { FC } from 'react'
import React from 'react'
import styles from './FindAddressOnMap.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { useErrorHandling, withErrorBoundary } from '@/tools/o11y/client'
import { SearchInput, SearchSize } from '@/tools/ui'
import { useAddressBookContext } from '@/user/address-book/AddressBookContext'

export const FindAddressOnMap: FC = withErrorBoundary(
  () => {
    const { withErrorTracking } = useErrorHandling()
    const { navigate } = useAddressBookContext()
    const { t } = useLocalisation()

    const handleSearchClick = withErrorTracking(() => {
      navigate('useSearchInstead')
    })

    return (
      <div className={styles.findOnMap}>
        <div className={styles.findOnMapText}>
          <p>{t('address-list.trouble-locating-address')}</p>
          <p>{t('address-list.try-using-search-instead')}</p>
        </div>

        <div role={'search'} onClick={handleSearchClick}>
          <SearchInput
            aria-label={t('common.search')}
            placeholder={t('address.location_form.search_street_label')}
            size={SearchSize.small}
          />
        </div>
      </div>
    )
  },
  {
    id: 'user.address_book.step.find_address_on_map',
    owner: Teams.WEBX,
  }
)
